import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { isAppWebView } from "utils/api";
import { PREMIUM_DEFAULT_SUB_TITLE } from "constants/lessonRequest";
import "./courseCard.scss";

// 프리미엄 트레이닝(유료 연습반) 판별 — 일반 연습반과 시각적으로 구분
const isPremiumTraining = (lesson) =>
    lesson?.practice_type === "REGULAR_TRAINING" ||
    !!lesson?.title?.includes("프리미엄 트레이닝");

/**
 * @param {object} schedule          예약 가능한 스케쥴 정보
 * @param {string} status            예약 상태
 */
const CourseCard = ({ type, schedule }) => {
    const navigate = useNavigate();
    const today = dayjs();
    const isPast = dayjs(schedule.date).isBefore(today, "day");
    const isCancel = schedule.status === "CANCELLED"
    const isPremium = isPremiumTraining(schedule);

    return (
        <div
            className={`course-card-wrap${isPremium ? " premium" : ""}`}
            onClick={() => {
                // 앱 WebView 에서 window.open 은 네이티브 팝업 레이어를 만드는데,
                // 레이어에서 진행되는 결제(유료 연습반)는 외부 결제앱 왕복을 견디지
                // 못한다. 앱은 메인 WebView 에 머무는 navigate 로 이동하고
                // (목록 필터는 Reservation 의 sessionStorage 복원으로 유지),
                // 웹 브라우저는 기존 새 탭 UX 를 유지한다.
                if (isAppWebView()) {
                    navigate(`/reservation/${type}/${schedule.id}`);
                } else {
                    window.open(`/reservation/${type}/${schedule.id}`, "_blank");
                }
            }}
        >
            {isPremium && (
                <div className="premium-eyebrow">
                    <span className="premium-badge">PREMIUM</span>
                    <span className="premium-coaching">
                        {schedule.sub_title || PREMIUM_DEFAULT_SUB_TITLE}
                    </span>
                </div>
            )}
            <div className="course-card-info-wrap">
                <p className="course-name">
                    {schedule.lesson_product_display_name || schedule.title}
                </p>
                <div className="course-time-wrap">
                    <p>
                        {schedule.start_time.slice(0, -3)} -{" "}
                        {schedule.end_time.slice(0, -3)}
                    </p>
                </div>
            </div>
            <div>
                <p className="instructor-info">
                    <span className="location">{schedule.location_name} </span>
                    {schedule?.home_brand && <span className="home-brand">
                        {` ・  ${schedule.home_brand}`}
                    </span>}
                    <span className="instructor">
                        {` ・  ${schedule.instructor_name} 강사`}
                    </span>
                </p>
            </div>
            <div className="reservation-info">
                <p className="capacity">
                    <span>{schedule.current_bookings}명 신청</span>
                    {schedule.current_bookings >= schedule.capacity ? (
                        schedule.waiting_count > 0 ? (
                            <span className="full"> · 대기 {schedule.waiting_count}명</span>
                        ) : (
                            <span className="full"> · 대기 가능</span>
                        )
                    ) : (
                        <span> · 잔여 {schedule.capacity - schedule.current_bookings}자리</span>
                    )}
                </p>
                {isPast || isCancel ? (
                    <p className="reservation-btn disabled">
                        {isPast && "마감"}
                        {!isPast && isCancel && "취소됨"}
                    </p>
                ) : (
                    <p className="reservation-btn">
                        {schedule.current_bookings >= schedule.capacity
                            ? "대기신청"
                            : "신청하기"}
                    </p>
                )}
            </div>
        </div>
    );
};

export default CourseCard;
